<template>
  <div>
    <b-card
        border-variant="secondary"
        header-bg-variant="secondary"
        header-text-variant="white"
        :header="$t('unitChanges.changeHeader')"
        :title="$t('authTokenChange.header')"
        align="center"
        class="mx-auto"
        style="max-width: 40rem;"

    >
      <b-icon class="h2" icon="exclamation-triangle-fill" variant="warning"></b-icon>
      <p> {{ $t("authTokenChange.accessWarning")}}</p>
      <b-button @click="onChange" class="m-2" variant="outline-primary">{{$t('buttonDefaults.change')}}</b-button>
      <b-button @click="onCancel" class="m-2" variant="outline-primary" >{{ $t("buttonDefaults.cancel")}}</b-button>
    </b-card>
  </div>
</template>

<script>
import router from '@/router/index'
import store from "@/store/store";
import unitApi from "@/services/unitApi";

export default {
  name: 'ChangePortalAccessToken',
  props: {
    changeRequested: { type: String }
  },

  data() {
    return {
      unit: {
            status: 'ENABLED'
      }
    }
  },
  methods: {
    onCancel(){
      router.push({ name: 'Unit'})
    },
    async onChange(){
      this.unit.status="TOKEN_RESET"
      try {
        await unitApi.updateUnit(store.getters.getTenantGuid, this.unit)
        await router.push("/portal/unauthorized")
      }catch(e){
        if(e.response.status === 409  || e.response.status === 400) {
          this.$bvToast.toast(e.response.data.message, {
            title: this.$t('authTokenChange.failed'),
            autoHideDelay: 10000,
            toaster: "b-toaster-top-center",
            variant: "warning",
            append: false,
            solid: false
          })
        }
        else {
                  this.$bvToast.toast(this.$t('authTokenChange.failedMsg'), {
                    title: this.$t('authTokenChange.failed'),
                    autoHideDelay: 10000,
                    toaster: "b-toaster-top-center",
                    variant: "warning",
                    append: false,
                    solid: false
                  })
                }
      }
    }
  }

}
</script>
